import { memo } from 'react';

import { CalculationsSectionObserver } from './CalculationsSectionObserver';
import { UnitRecalculationTracker } from './UnitRecalculationTracker';
import { IObservedFormsType, observedFields } from './utils/form';

export const CalculationsObserver = memo(() => {
  return (
    <>
      <UnitRecalculationTracker />
      {Object.keys(observedFields).map((formName) => {
        const key = formName as IObservedFormsType;
        return (
          <CalculationsSectionObserver
            key={key}
            fieldNames={observedFields[key].observeValueChangeFieldNames}
            formName={key}
          />
        );
      })}
    </>
  );
});
